import {CookiesConsentStatus} from 'racebox-store-package';
class CookieConsentPopup {
    constructor(privacyPolicyUrl) {
        this.element = null;
        this.privacyPolicyUrl = privacyPolicyUrl;
    }

    buildElement() {
        if (this.element) {
            return;
        }
        this.element = document.createElement('div');
        this.element.id = 'cookie-consent-popup';
        this.element.innerHTML =
            '<div class="background">' +
            '<div class="content">' +
            '<div class="content-inner">' +
            '<form action="?" method="get">' +
            '<p>We use cookies to provide you with the best experience on our website. By clicking "I accept" you agree ' +
            'to our use of cookies in accordance with our <a href="' + this.privacyPolicyUrl + '">privacy policy</a>.</p>' +
            '<div class="cbcontainer">' +
            '<input type="checkbox" id="ccp-analytics-cb" name="cookie-consent-analytics" value="analytics" checked>' +
            '<label for="ccp-analytics-cb">Allow analytics cookies</label>' +
            '</div>' +
            '<p>These cookies allow us to measure visitors traffic and see traffic sources by collecting information ' +
            'in data sets. They also help us understand which products and actions are more popular than others.</p>' +
            '<div class="cbcontainer">' +
            '<input type="checkbox" id="ccp-marketing-cb" name="cookie-consent-marketing" value="marketing" checked>' +
            '<label for="ccp-marketing-cb">Allow marketing cookies</label>' +
            '</div>' +
            '<p>These cookies are used to track visitors across websites. The intention is to display ads that are ' +
            'relevant and engaging for the individual user and thereby more valuable for publishers and third party ' +
            'advertisers.</p>' +
            '<div class="cbcontainer">' +
            '<input type="checkbox" id="ccp-essential-cb" name="cookie-consent-essential" value="essential" checked disabled>' +
            '<label for="ccp-essential-cb">Allow essential cookies</label>' +
            '</div>' +
            '<p>These cookies are required for the website to run and cannot be switched off. Such cookies are only set ' +
            'in response to actions made by you such as logging in, adding items to your card or changing your region. ' +
            'You can set your browser to block these cookies but this will affect the way our site is working.' +
            '</p>' +
            '<div class="submitcontainer"><button class="submit" name="accept-all">I accept all</button></div>' +
            '<div class="submitcontainer"><button name="save-preferences">Save preferences</button></div>' +
            '<div class="submitcontainer"><button name="reject-all">Reject all</button></div>' +
            '</form>' +
            '</div></div>' +
            '</div>';
        this.element.style.display = 'none';
        document.body.appendChild(this.element);
        this.element.querySelector('form').addEventListener('submit', (e) => this.onSubmit(e));
    }

    show() {
        this.buildElement();
        this.element.style.display = 'block';
        // find each checkbox and determine if it should be checked
        this.element.querySelectorAll('input[type="checkbox"]').forEach((el) => {
            el.checked = el.disabled || CookiesConsentStatus.isAccepted(el.value);
        });
    }

    onSubmit(event) {
        event.preventDefault();
        this.element.style.display = 'none';

        const allCheckboxes = this.element.querySelectorAll('input[type="checkbox"]');

        // the event is a form submit. Check which button was clicked

        if (event.submitter.name === 'accept-all') {
            allCheckboxes.forEach((el) => {
                el.checked = true;
            });
        } else if (event.submitter.name === 'reject-all') {
            allCheckboxes.forEach((el) => {
                el.checked = el.disabled; // only essential cookies should be checked
            });
        }

        let acceptedTypes = [];
        allCheckboxes.forEach((el) => {
            if (el.checked) {
                acceptedTypes.push(el.value);
            }
        });

        CookiesConsentStatus.setAccepted(acceptedTypes);
    }

    showIfNeeded() {
        if (CookiesConsentStatus.isEU() && !CookiesConsentStatus.hasConsented()) {
            this.show();
        }
    }
}

export {CookieConsentPopup};

document.addEventListener('DOMContentLoaded', () => {
    window.cookieConsentPopup = new CookieConsentPopup(window.privacyPolicyUrl ?? '/privacy-policy');
    window.cookieConsentPopup.showIfNeeded();
    document.querySelectorAll('.cookie-consent-popup-trigger').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            window.cookieConsentPopup.show();
        });
    });
});